export default __webpack_public_path__ + "static/media/logo_non_data.a395e2e0.png";